import React, { createContext, FC, useContext } from 'react';
import type { NodeInstance } from '@glueapp/graph-types';

export const CurrentNodeInstanceContext = createContext<NodeInstance | null>(null);

interface CurrentNodeInstanceContextProviderProps {
    nodeInstance: NodeInstance;
    children: React.ReactNode;
}

export const CurrentNodeInstanceContextProvider: FC<CurrentNodeInstanceContextProviderProps> = props => {
    return <CurrentNodeInstanceContext.Provider value={props.nodeInstance}>{props.children}</CurrentNodeInstanceContext.Provider>;
};

export function useCurrentNodeInstance(): NodeInstance {
    const nodeInstance = useContext(CurrentNodeInstanceContext);
    if (!nodeInstance) {
        throw new Error('useCurrentNodeInstance must be used within a CurrentNodeInstanceContextProvider');
    }
    return nodeInstance;
}
